export const GET_PATIENTS = "PATIENTS";
export const GET_VISITS = "VISITS";
export const GET_LOGIN = "LOGIN";
export const GET_TOKEN = "TOKEN";
